import { Component, OnInit, ViewChild, ElementRef, Input, ChangeDetectorRef } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { filterDateAnim } from 'src/app/models/consts/anims';
import { MediaObserver } from '@angular/flex-layout';
import { ToolsService } from 'src/app/services/tools/tools.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CurrencyService } from 'src/app/services/manage/currency/currency.service';
import { ClientMerchantsService } from 'src/app/services/apiclient/clientmerchants/clientmerchants.service';
import { ClientCreditsService } from 'src/app/services/apiclient/clientcredits/clientcredits.service';
import { TranslateArrayService } from 'src/app/services/translateArray/translate';



@Component({
  selector: 'app-credits-history',
  templateUrl: './credits-history.component.html',
  styleUrls: ['./credits-history.component.css']
  ,
  animations: [
    filterDateAnim,
  ]
})
export class CreditsHistoryComponent implements OnInit {

  @ViewChild('pageTitle') pageTitle: ElementRef|any;
  @ViewChild(MatPaginator) paginator: MatPaginator|any;
  @ViewChild(MatSort) sort: MatSort|any;

  @Input("selectedTabIndex") visible: any;
  @Input("payed") payed: any;
  client_credits$: any[]|any;

  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>();
  displayedColumns: string[] = ['date', 'user_denomination', 'point_of_sale_name', 'lettering', 'total', 'print'];


  loader: boolean = true;
  creditLoader: boolean = false;

  titlePositionTop: number|any;

  filterDateAnimFlag: boolean = false;
  get getToggleFilterDate(): string { return this.filterDateAnimFlag ? "show" : "hide"; }

  currMerchant: any;

  credits_: any = [];
  count: any;

  display_number: number = 5;

  display_element: any = {
    offset: 0,
    limit: this.display_number
  };

  paginatorPage: any = {
    pageIndex: 0,
    pageSize: this.display_number
  };

  pageIndex: number = 0;


  constructor(
    private media: MediaObserver,
    private ClientCreditsService: ClientCreditsService,
    private tools: ToolsService,
    private route: ActivatedRoute,
    private router: Router,
    private clientMerchantApi: ClientMerchantsService,
    private currencyMng: CurrencyService,
    private ref: ChangeDetectorRef,
    private TranslateArrayService: TranslateArrayService

  ) {
    this.media.asObservable().subscribe(media => {
      if (this.titlePositionTop) {
        this.setTitlePosition();
      }
    });
  }

  ngOnInit() {
    this.init();
  }

  init() {
    //get params
    this.route.params.subscribe((params:any) => {
      this.loader = true;
      if (params.merchantId) {
        this.clientMerchantApi.getMerchant(params.merchantId).subscribe(merchant => {
          this.currMerchant = merchant;
          this.currencyMng.setCurrCurrency(merchant.currency);
          this.getCredits();
        });
      } else {
        this.tools.setPageClient("credits");
        this.getCredits();
      }
    });
  }

  ngAfterViewInit() {
    //paginator
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.TranslateArrayService.get(this.dataSource.paginator);
  }

  getCredits() {
    const merchantId = (this.currMerchant) ? parseInt(this.currMerchant.id_user) : null;
    this.ClientCreditsService.getCreditsLetter(null, null, merchantId, this.display_element).subscribe((credits_value: any) => {
      this.setmyCredits(credits_value);
    });
  }

  transformForArray(cred: any) {
    let credits :any= [];
    cred.forEach((element: any, i: any) => {
      let cre = {
        currency: element.currency,
        date: element.date,
        user_denomination: element.user_account.denomination,
        point_of_sale_name: element.point_of_sale.denomination,
        lettering: element.lettering,
        total: element.credit_history.total,
        print: element.link_lettering,
      }
      credits.push(cre);
    });
    return credits;
  }

  setcreditLoader($event: boolean) {
    if ($event) {this.filterDateAnimFlag = false;}
    this.creditLoader = $event;
  }

  setCredits(ev: any) {
    //on vide le tableau credits car on vient de faire une recherche par date
    if (Array.isArray(ev)) {
      this.credits_ = [];
      this.count = 0;
      this.paginatorPage = {
        pageIndex: 0,
        pageSize: this.display_number
      };
      this.setNewCredits(ev);
    }
    else {
      //on set le tableau
      this.setmyCredits(ev);
    }
  }

  setmyCredits($ev: any) {
    let credits: any = this.transformForArray($ev.clientCredits);
    this.credits_ = this.credits_.concat(credits);
    this.count = $ev.count;
    this.setNewCredits();
  }

  setNewCredits($search?: any) {
    setTimeout(() => {
      this.dataSource.data = this.credits_;
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.TranslateArrayService.get(this.dataSource.paginator);

    });


    setTimeout(() => {

      this.paginator.length = this.count;
      this.paginator.pageIndex = this.paginatorPage.pageIndex;
      this.paginator.pageSize = this.paginatorPage.pageSize;

    }, 0);


    this.setTitlePosition();
    this.ref.detectChanges();


    if (!$search) {
      this.setcreditLoader(false);
      this.loader = false;
    }

  }




  /**
   * @description  onPaginationChange
   * @params $e event
   * 
   */
  onPaginationChange($e: any) {

    this.paginatorPage = {
      pageIndex: $e.pageIndex,
      pageSize: $e.pageSize
    }

    let element_page = $e.pageSize * ($e.pageIndex + 1)//nombre d'element affichés
    let pageLenght = element_page < this.count ? element_page : this.count;

    if (pageLenght > this.credits_.length && this.credits_.length < this.count) {

      this.display_element.limit = pageLenght - this.credits_.length;
      this.display_element.offset = this.credits_.length;
      this.setcreditLoader(true);
      this.getCredits();

    }

  }






  goPrintTicket(link_lettering: string) {
    window.open(link_lettering);
  }
  goBack(): void {
    this.router.navigate(["/home/merchantOptions/" + this.currMerchant.id_user]);
  }


  setTitlePosition() {
    setTimeout(() => {
      this.titlePositionTop = this.pageTitle?.nativeElement.getBoundingClientRect().top - 50;

      if(this.currMerchant && !this.filterDateAnimFlag){
        this.titlePositionTop=0;
      }
     
    });
  }

  setFilteranim(){
  this.filterDateAnimFlag = !this.filterDateAnimFlag,
  this.setTitlePosition(); }

}
